import PocketBase from 'pocketbase';

/**
 * Lazy-initialisierter PocketBase-Client.
 *
 * Liest `VITE_POCKETBASE_URL` aus `import.meta.env`. Ist die Variable gesetzt
 * (und ist HTTPS), gibt `getPocketBase()` einen funktionsfaehigen Client zurueck.
 * Andernfalls ist `getPocketBase()` `null` und die App laeuft im Anonym-Modus
 * (lokal-only, exakt das vorherige Verhalten).
 *
 * Setup-Anleitung: `docs/pocketbase-setup.md`.
 */

interface PocketBaseEnv {
  url: string;
}

function readEnv(): PocketBaseEnv | null {
  const env = import.meta.env as Record<string, string | undefined>;
  const url = env['VITE_POCKETBASE_URL'];
  if (!url) return null;
  if (!url.startsWith('https://') && !url.startsWith('http://localhost')) return null;
  return { url };
}

let cached: PocketBase | null | undefined;

export function getPocketBase(): PocketBase | null {
  if (cached !== undefined) return cached;
  const env = readEnv();
  if (!env) {
    cached = null;
    return null;
  }
  cached = new PocketBase(env.url);
  return cached;
}

/**
 * `true`, wenn die App mit PocketBase-Backend laeuft. Wird in der UI
 * verwendet, um den Anmelden-Button zu kontextualisieren.
 */
export function isCloudConfigured(): boolean {
  return getPocketBase() !== null;
}

/** Test-Helper. NICHT im App-Code verwenden. */
export function __resetPocketBaseForTests(): void {
  cached = undefined;
}
